import type { FC } from 'react';

import { XClose as Component } from '@untitledui-pro/icons/line/XClose';

import { BaseIcon, type IconProps } from '../../base-icon/base-icon.tsx';

export type XCloseProps = IconProps;

export const XClose: FC<XCloseProps> = (props) => <BaseIcon {...props} Component={Component} />;
